module.exports = __webpack_public_path__ + "static/img/logo.00b0f899.png";